import Handlebars from 'handlebars';

export function registerCountdownHelper() {
  Handlebars.registerHelper('countdown', (options) => {
    // Required parameters validation
    const countdownId = options.hash.countdownId || '';
    if (!countdownId) {
      console.error('Countdown helper requires a countdownId parameter');
      return 'Error: No countdownId provided';
    }

    const finishDate = options.hash.finishDate || '';
    if (!finishDate) {
      console.error('Countdown helper requires a finishDate parameter');
      return 'Error: No finish date provided';
    }

    const parentContentId = options.hash.parentContentId || '';
    const hideParent = !!options.hash.hideParent;

    // Optional parameters
    const locale = options.hash.locale || 'en-GB';
    const timezone = options.hash.timezone || '';

    // Text labels with singular/plural support
    const textDays = options.hash.textDays || 'days';
    const textDay = options.hash.textDay || 'day';
    const textHours = options.hash.textHours || 'hours';
    const textHour = options.hash.textHour || 'hour';
    const textMinutes = options.hash.textMinutes || 'minutes';
    const textMinute = options.hash.textMinute || 'minute';
    const textSeconds = options.hash.textSeconds || 'seconds';
    const textSecond = options.hash.textSecond || 'second';

    // Display configuration
    const separator = options.hash.separator || ', ';
    const showDays = options.hash.showDays !== false; // Default to true
    const showHours = options.hash.showHours !== false; // Default to true
    const showMinutes = options.hash.showMinutes !== false; // Default to true
    const showSeconds = !!options.hash.showSeconds; // Default to false

    // Accessibility enhancements
    const ariaLabel =
      options.hash.ariaLabel || `Countdown timer until ${new Date(finishDate).toLocaleDateString(locale)}`;

    // Initial text for hydration safety and accessibility
    const initialText = options.hash.initialText || 'Countdown loading...';

    // For hydration safety, render a static representation initially
    // This must be identical between server and client rendering

    const output = `<span
    id="${countdownId}"
    class="countdown-text"
    data-countdown="true"
    data-finish-date="${finishDate}"
    data-parent-content-id="${parentContentId}"
    data-hide-parent="${hideParent}"
    data-locale="${locale}"
    data-timezone="${timezone}"
    data-text-days="${textDays}"
    data-text-day="${textDay}"
    data-text-hours="${textHours}"
    data-text-hour="${textHour}"
    data-text-minutes="${textMinutes}"
    data-text-minute="${textMinute}"
    data-text-seconds="${textSeconds}"
    data-text-second="${textSecond}"
    data-separator="${separator}"
    data-show-days="${showDays}"
    data-show-hours="${showHours}"
    data-show-minutes="${showMinutes}"
    data-show-seconds="${showSeconds}"
    role="timer"
    aria-label="${ariaLabel}"
    aria-live="polite"
  >
    <!-- Static content for initial render and non-JS fallback -->
    <noscript>JavaScript is required to display the countdown</noscript>
    <span class="countdown-static">${initialText}</span>
  </span>`;

    // Return the HTML as a SafeString
    return new Handlebars.SafeString(output);
  });
}
